module.exports = __webpack_public_path__ + "img/shoplogo.f8310d43.svg";